import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

enum RoomModerationEvent {
    MUTE_USER = "mute_user",
    BAN_USER = "ban_user",
}

interface RoomModerationEventDetails {
    readonly roomId: string;
    readonly actionPerformerUid: string;
    readonly targetUserUid: string;
}

export class MuteUserEvent extends AmplitudeEvent {
    constructor(eventDetails: RoomModerationEventDetails) {
        super(RoomModerationEvent.MUTE_USER);
        this.props = { ...eventDetails };
    }
}

export class BanUserEvent extends AmplitudeEvent {
    constructor(eventDetails: RoomModerationEventDetails) {
        super(RoomModerationEvent.BAN_USER);
        this.props = { ...eventDetails };
    }
}
